// extracted by mini-css-extract-plugin
export var checkbox = "_8x-0";
export var circle = "_8x-3";
export var horizontalContainer = "_8x-7";
export var sm = "_8x-5";
export var switch0 = "_8x-2";
export var switchDisabled = "_8x-8";
export var switchEnabled = "_8x-1";
export var textSwitchContainer = "_8x-9";
export var textSwitchOption = "_8x-a";
export var textSwitchOptionSelected = "_8x-b";
export var verticalContainer = "_8x-6";
export var xs = "_8x-4";